import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import * as Chart from 'chart.js'
import 'fullcalendar';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  // COUNT
  count: number = 0;

  // ELEMENTOS CHARTS
  myChart: Chart = [];

  // JSON API
  tarifasarr: any;
  tarifasjson: any[] = [];
  tartestkey: any[] = [];
  tartestvalue: any[] = [];

  // **Bingos**
  // Gorrion
  fechasG: any[] = [];
  importeG: any[] = [];
  fechasG17: any[] = [];
  importeG17: any[] = [];
  // Navas
  fechasN: any[] = [];
  importeN: any[] = [];
  fechaN17: any[] = [];
  importeN17: any[] = [];
  // Costa
  fechasC: any[] = [];
  importeC: any[] = [];
  fechasC17: any[] = [];
  importeC17: any[] = [];
  // Riscal
  fechasR: any[] = [];
  importeR: any[] = [];
  fechasR17: any[] = [];
  importeR17: any[] = [];

  // Totales
  fechasGlobal: any[] = [];
  importeGlobal: any[] = [];


  constructor(public rest: RestService) { }

  ngOnInit() {
    // IONIC PART
    this.getapi();
    this.chargAll();
  }

  // IONIC PART
  chargAll() {
    setTimeout(() => {
      this.cargChart();
      setTimeout(() => {
        this.addNavas();
        this.addCosta();
        this.addRiscal();
      }, 50);
    }, 800);
  }
  cargChart() {
    const ctx2 = document.getElementById('myChart2');
    // CREATE CHART
    this.myChart = new Chart(ctx2, {
      type: 'line',
      data: {
        labels: this.fechasG,
        datasets: [{
          label: 'Gorrión',
          data: this.importeG,
          backgroundColor: [
            'rgba(0,159,0,0.3)',
            'rgba(0,33,0,0.3)',

          ],
          borderColor: [
            'rgba(0,159,0,0.3)',
            'rgba(0,51,0,0.3)',
          ],
          borderWidth: 2,
          hoverBorderWidth: 0
        }]
      },
      options: {
        title: {
          display: true,
          text: 'Facturación Bingos'
        }
      }
    });
  }

  // GET APIS AND DECODE
  getapi() {
    this.rest.getsala('gorrion')
      .subscribe((data) => {
        this.arr2json(data, this.fechasG, this.importeG);
      });
    this.rest.getsala('navas')
      .subscribe((data) => {
        this.arr2json(data, this.fechasN, this.importeN);
      });
    this.rest.getsala('costablanca')
      .subscribe((data) => {
        this.arr2json(data, this.fechasC, this.importeC);
      });
    this.rest.getsala('riscal')
      .subscribe((data) => {
        this.arr2json(data, this.fechasR, this.importeR);
      });
  }

  // Función para providers
  arr2json(data, fecha, importe) {
    console.log('Data', data);
    data.forEach(data => {
      fecha.push(data['Fecha']);
      importe.push((parseInt(data['Importe']) / 1000000));
    });
  }

  // CHART JS  ANGULAR
  addData(chart, label, data) {
    chart.data.labels.push(label);
    chart.data.datasets.forEach((dataset) => {
      dataset.data.push(data);
    });
    chart.update();
  }

  removeData(chart) {
    chart.data.labels.pop();
    chart.data.datasets.forEach((dataset) => {
      dataset.data.pop();
    });
    chart.update();
  }

  // DATASET
  addDataset(chart, $nombre, $data) {
    const newDataset = {
      label: $nombre,
      data: $data,
      backgroundColor: [
        'rgba(240,99,132,0.6)',
        'rgba(231,99,132,0.6)',
        'rgba(222,99,132,0.6)',
        'rgba(213,99,132,0.6)',
        'rgba(204,99,132,0.6)',
        'rgba(195,99,132,0.6)',
        'rgba(186,99,132,0.6)',
        'rgba(177,99,132,0.6)',
        'rgba(168,99,132,0.6)',
        'rgba(159,99,132,0.6)',
        'rgba(150,99,132,0.6)',
        'rgba(141,99,132,0.6)',
        'rgba(132,99,132,0.6)',
        'rgba(123,99,132,0.6)',
        'rgba(114,99,132,0.6)',
        'rgba(105,99,132,0.6)',
        'rgba(96,99,132,0.6)',
        'rgba(87,99,132,0.6)',
        'rgba(78,99,132,0.6)',
        'rgba(69,99,132,0.6)',
        'rgba(60,99,132,0.6)',
        'rgba(51,99,132,0.6)',
        'rgba(42,99,132,0.6)',
        'rgba(33,99,132,0.6)',
        'rgba(24,99,132,0.6)'
      ],
      borderColor: [
        'rgba(240,99,132,0.6)',
        'rgba(231,99,132,0.6)',
        'rgba(222,99,132,0.6)',
        'rgba(213,99,132,0.6)',
        'rgba(204,99,132,0.6)',
        'rgba(195,99,132,0.6)',
        'rgba(186,99,132,0.6)',
        'rgba(177,99,132,0.6)',
        'rgba(168,99,132,0.6)',
        'rgba(159,99,132,0.6)',
        'rgba(150,99,132,0.6)',
        'rgba(141,99,132,0.6)',
        'rgba(132,99,132,0.6)',
        'rgba(123,99,132,0.6)',
        'rgba(114,99,132,0.6)',
        'rgba(105,99,132,0.6)',
        'rgba(96,99,132,0.6)',
        'rgba(87,99,132,0.6)',
        'rgba(78,99,132,0.6)',
        'rgba(69,99,132,0.6)',
        'rgba(60,99,132,0.6)',
        'rgba(51,99,132,0.6)',
        'rgba(42,99,132,0.6)',
        'rgba(33,99,132,0.6)',
        'rgba(24,99,132,0.6)'
      ],
    };
    chart.data.datasets.push(newDataset);
    chart.update();
  }
  addDataset2(chart, $nombre, $data) {
    const newDataset = {
      label: $nombre,
      data: $data,
      backgroundColor: [
        'rgba(0,240,0,0.3)',
        'rgba(0,231,0,0.3)',
        'rgba(0,222,0,0.3)',
        'rgba(0,213,0,0.3)',
        'rgba(0,204,0,0.3)',
        'rgba(0,195,0,0.3)',
        'rgba(0,186,0,0.3)',
        'rgba(0,177,0,0.3)',
        'rgba(0,168,0,0.3)',
        'rgba(0,159,0,0.3)',
        'rgba(0,150,0,0.3)',
        'rgba(0,141,0,0.3)',
        'rgba(0,132,0,0.3)',
        'rgba(0,123,0,0.3)',
        'rgba(0,114,0,0.3)',
        'rgba(0,105,0,0.3)',
        'rgba(0,96,0,0.3)',
        'rgba(0,87,0,0.3)',
        'rgba(0,78,0,0.3)',
        'rgba(0,69,0,0.3)',
        'rgba(0,60,0,0.3)',
        'rgba(0,51,0,0.3)',
        'rgba(0,42,0,0.3)',
        'rgba(0,33,0,0.3)',
        'rgba(0,24,0,0.3)'
      ],
      borderColor: [
        'rgba(0,240,0,0.3)',
        'rgba(0,231,0,0.3)',
        'rgba(0,222,0,0.3)',
        'rgba(0,213,0,0.3)',
        'rgba(0,204,0,0.3)',
        'rgba(0,195,0,0.3)',
        'rgba(0,186,0,0.3)',
        'rgba(0,177,0,0.3)',
        'rgba(0,168,0,0.3)',
        'rgba(0,159,0,0.3)',
        'rgba(0,150,0,0.3)',
        'rgba(0,141,0,0.3)',
        'rgba(0,132,0,0.3)',
        'rgba(0,123,0,0.3)',
        'rgba(0,114,0,0.3)',
        'rgba(0,105,0,0.3)',
        'rgba(0,96,0,0.3)',
        'rgba(0,87,0,0.3)',
        'rgba(0,78,0,0.3)',
        'rgba(0,69,0,0.3)',
        'rgba(0,60,0,0.3)',
        'rgba(0,51,0,0.3)',
        'rgba(0,42,0,0.3)',
        'rgba(0,33,0,0.3)',
        'rgba(0,24,0,0.3)'
      ],
    }
    chart.data.datasets.push(newDataset);
    chart.update();
  }

  // ADD DATASETS
  addNavas() {
    this.addDataset2(this.myChart, 'Navas', this.importeN);
  }
  addCosta() {
    this.addDataset(this.myChart, 'Costa Blanca', this.importeC);
  }
  addRiscal() {
    this.addDataset2(this.myChart, 'Riscal', this.importeR);
  }

}
